import { memo, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getColor } from 'basic-components';

import dsHooks from 'hooks/modules/datascience';

import { Else, If, Then } from 'react-if';

import './CollapsedComment.scss';

const CollapsedComment = ({ commentId, setVisible }) => {
  const number = useSelector(state => state.datascienceState.creatorState.builderState.comments.findIndex(c => c.id === commentId) + 1),
        executing = useSelector(state => state.datascienceState.creatorState.basicState.executing),
        isBlockedByWarehouse = dsHooks.useIsBlockedByWarehouseAccess(),
        disabled = executing || isBlockedByWarehouse,
        [dragging, setDragging] = useState(false),
        setDraggingTrue = useCallback(() => !disabled && setDragging(true), [disabled]),
        setDraggingFalse = useCallback(() => !disabled && setDragging(false), [disabled])
  
  return (
    <div 
        className="data-science__pipeline-creator__comments__comment__collapsed"
        onDoubleClick={() => setVisible()}
        onMouseDown={setDraggingTrue}
        onMouseUp={setDraggingFalse}
    >
      <svg viewBox="0 0 48 48">
        <defs>          
          <filter 
              filterUnits="objectBoundingBox"
              height="154.2%" 
              id="prefix__a" 
              width="154.2%"
              x="-27.1%" 
              y="-22.9%" 
          >
              <feOffset 
                  dy="2" 
                  in="SourceAlpha" 
                  result="shadowOffsetOuter1"
              />
              <feGaussianBlur 
                  in="shadowOffsetOuter1" 
                  result="shadowBlurOuter1" 
                  stdDeviation="4"
              />
              <feColorMatrix 
                  in="shadowBlurOuter1" 
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
              />
          </filter>
        </defs>
        <If condition={dragging}>
          <Then>
            <path 
                d="M40.955 7.033C36.42 2.496 30.401 0 23.988 0 17.574 0 11.557 2.496 7.02 7.033c-8.767 8.767-9.376 22.802-1.512 32.27-.77 1.553-2.009 3.36-3.846 4.262-.883.437-1.38 1.38-1.228 2.355.153.974.904 1.735 1.878 1.887.456.071 1.106.142 1.897.142 2.121 0 5.247-.497 8.444-2.8C16.215 47.065 20.11 48 23.978 48c6.21 0 12.36-2.405 16.988-7.033 4.536-4.536 7.032-10.553 7.032-16.967 0-6.414-2.506-12.431-7.043-16.967z"
                fill={getColor("black-base")}
                filter="url(#prefix__a)" 
                strokeDasharray="4 4" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M40.955 7.033C36.42 2.496 30.401 0 23.988 0 17.574 0 11.557 2.496 7.02 7.033c-8.767 8.767-9.376 22.802-1.512 32.27-.77 1.553-2.009 3.36-3.846 4.262-.883.437-1.38 1.38-1.228 2.355.153.974.904 1.735 1.878 1.887.456.071 1.106.142 1.897.142 2.121 0 5.247-.497 8.444-2.8C16.215 47.065 20.11 48 23.978 48c6.21 0 12.36-2.405 16.988-7.033 4.536-4.536 7.032-10.553 7.032-16.967 0-6.414-2.506-12.431-7.043-16.967z"    
                fill={getColor("white-base")}
                stroke={getColor("grey-hover")}
                strokeDasharray="4 4" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
          </Then>
          <Else>
            <path 
                d="M40.955 7.033C36.42 2.496 30.401 0 23.988 0 17.574 0 11.557 2.496 7.02 7.033c-8.767 8.767-9.376 22.802-1.512 32.27-.77 1.553-2.009 3.36-3.846 4.262-.883.437-1.38 1.38-1.228 2.355.153.974.904 1.735 1.878 1.887.456.071 1.106.142 1.897.142 2.121 0 5.247-.497 8.444-2.8C16.215 47.065 20.11 48 23.978 48c6.21 0 12.36-2.405 16.988-7.033 4.536-4.536 7.032-10.553 7.032-16.967 0-6.414-2.506-12.431-7.043-16.967z"
                fill={getColor("black-base")}
                filter="url(#prefix__a)" 
            />
            <path 
                d="M40.955 7.033C36.42 2.496 30.401 0 23.988 0 17.574 0 11.557 2.496 7.02 7.033c-8.767 8.767-9.376 22.802-1.512 32.27-.77 1.553-2.009 3.36-3.846 4.262-.883.437-1.38 1.38-1.228 2.355.153.974.904 1.735 1.878 1.887.456.071 1.106.142 1.897.142 2.121 0 5.247-.497 8.444-2.8C16.215 47.065 20.11 48 23.978 48c6.21 0 12.36-2.405 16.988-7.033 4.536-4.536 7.032-10.553 7.032-16.967 0-6.414-2.506-12.431-7.043-16.967z"    
                fill={getColor("white-base")}
            />
          </Else>
        </If>
        <path 
            d="M37.165 37.156c-5.883 5.883-14.991 7.051-22.155 2.842-.471-.28-1.055-.192-1.43.183-.035.017-.07.043-.096.07-2.362 1.83-4.68 2.213-6.214 2.213h-.009c1.77-1.29 2.885-3.207 3.539-4.697.105-.253.122-.515.061-.759-.026-.235-.122-.47-.288-.662-6.38-7.208-6.048-18.19.767-25.005 7.121-7.121 18.704-7.121 25.816 0 7.13 7.12 7.13 18.695.009 25.815z"
            fill={getColor("yellow-base")}
        />
        <text>
          <tspan 
              dy="3"
              textAnchor="middle"
              x="50%"
              y="50%"
          >
            {number}
          </tspan>
        </text>
      </svg>
    </div>
  )
}

CollapsedComment.propTypes = {
  commentId: PropTypes.string.isRequired,
  setVisible: PropTypes.func.isRequired
}

export default memo(CollapsedComment);